module.exports = __webpack_public_path__ + "./images/white_thumb.15cf67.jpg";